import React from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  Redirect,
  withRouter,
} from "react-router-dom";
import PrivateRoutes, {
  AdminPrivateRoutes,
} from "./PrivateRoutes/PrivateRoutes";
import { getCookies, getUserData } from "../utils/utilsFunctions";
import ProtectedRoutes from "./ProtectedRoutes/ProtectedRoutes";
import HomePageScreen from "../Screen/HomePageScreen/HomePageScreen";
import Error404 from "./Error404/Error404";
import AboutUSPageScreen from "../Screen/AboutUsPageScreen/AboutUSPageScreen";
import ContactUsPageScreen from "../Screen/ContactUsPageScreen/ContactUsPageScreen";
import Marketplace from "../Screen/MarketplaceScreen/Marketplace";
import SignUpPage from "../Screen/SignUpPage/SignUpPage";
import SingleDesignPage from "../Screen/SingleDesignPage/SingleDesignPage";
import SignInPage from "../Screen/SignInpage/SignInpage";
import AdminProtedRoutes from "./ProtectedRoutes/AdminProtectedRoutes";
import Estimate from "../Screen/Dashboard/Designs/Estimate/Estimate";
import UploadNewDesignPageP from "../publicDesigns/UploadNewDesignPageP";
import UploadNewQSP from "../publicDesigns/UploadNewQSP";
import UploadNewDesignSelectPageP from "../publicDesigns/UploadNewDSPP";
import UploadNewPublishP from "../publicDesigns/UploadNewPublishP";
import PublicPrinters from "../publicPrinters/PublicPrinters";
import PublicSinglePrinter from "../publicPrinters/PublicSinglePrinter";
import UploadThumbnail from "../publicDesigns/UploadThumbnail";
import Cart from "../publicDesigns/Cart";
// import Profile from "../Screen/ProfileScreen/Profile";
import BecomeASellerPage from "../Screen/Dashboard/BecomeASeller";
import ProfileScreen from "../Screen/Dashboard/Profile/ProfileScreen";
import OtherInfoPage from "../publicDesigns/OtherInfoPage";
import ForgotPasswordScreen from "../Screen/ForgotPassword";
import ActiveAccountPage from "../Screen/ActiveteAccountScreen";
import WhyUse3Dmake from "../Components/WhyUse3Dmake";
import PrivacyPolicyScreen from "../Screen/PrivacyPolicyScreen/PrivacayPolicyScreen";

const MainRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact>
          <HomePageScreen />
        </Route>
        <Route path="/marketplace" exact>
          <Marketplace />
        </Route>
        <Route path="/aboutus" exact>
          <AboutUSPageScreen />
        </Route>
        <Route path="/why-use-3dprintit" exact>
          <WhyUse3Dmake />
        </Route>
        <Route path="/contactus" exact>
          <ContactUsPageScreen />
        </Route>
        <Route path="/privacy" exact>
          <PrivacyPolicyScreen />
        </Route>
        <Route path="/estimate">
          {" "}
          <Estimate />{" "}
        </Route>
        <Route path="/single" exact>
          <SingleDesignPage />
        </Route>
        <Route path="/register" exact>
          <SignUpPage />
        </Route>
        <Route
          path="/start-selling"
          exact
          component={BecomeASellerPage}
        >
        </Route>
        <Route
          path="/changePassword"
          exact
          component={ForgotPasswordScreen}
        >
        </Route>
        <Route
          path="/activateAccount"
          exact
          component={ActiveAccountPage}
        >
        </Route>
        <Route
          path="/design/upload"
          exact
          component={UploadNewDesignPageP}
        ></Route>
        <Route path="/design/quantity" exact component={UploadNewQSP}></Route>
        <Route
          path="/design/select"
          exact
          component={UploadNewDesignSelectPageP}
        ></Route>
        <Route
          path="/design/published"
          exact
          component={UploadNewPublishP}
        ></Route>
        <Route
          path="/design/other-info"
          exact
          component={OtherInfoPage}
        ></Route>
        <Route path="/design/thumbnail" exact component={UploadThumbnail}></Route>
        <Route path="/design/cart" exact component={Cart}></Route>

        <Route path="/design/:id" component={SingleDesignPage}></Route>

        <Route path="/printers" exact component={PublicPrinters}></Route>
        <Route
          path="/printers/:id"
          exact
          component={PublicSinglePrinter}
        ></Route>

        {/* For Stripe Test */}
        <Route path="/profile" exact component={ProfileScreen} />

        <Route path="/admin">
          <AdminPrivateRoutes Component={AdminProtedRoutes} />
        </Route>
        <Route path="/signin" exact>
          {!!getCookies() && !!getUserData() ? (
            <Redirect to="/dashboard" />
          ) : (
            <SignInPage />
          )}
        </Route>
        <PrivateRoutes Component={ProtectedRoutes} />
        <Route component={Error404} />
      </Switch>
    </BrowserRouter>
  );
};

export default withRouter(MainRouter);
